var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProfile = function SvgIconProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.96 12.5a9 9 0 1 0 18 0 9 9 0 0 0-18 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96 10.5a3 3 0 1 0 6 0 3 3 0 0 0-6 0M7.128 19.349A4 4 0 0 1 10.96 16.5h4a4 4 0 0 1 3.834 2.855"
  }))));
};
export default SvgIconProfile;